export class User {
  name: string;
  surname: string;
  userName: string;
  emailAddress: string;
  phoneNumber: string;
  profilePictureId: string;
  profilePicture: string;
  isEmailConfirmed: boolean;
  roles: Role[];
  permissions: string[];
  lastLoginTime: Date;
  isActive: boolean | undefined;
  creationTime: Date;
  id: number;
}

export class Role{
  roleId: number;
  roleName: string;
}

export class UserAccount{
  id: number;
  name: string;
  surname: string;
  userName: string;
  emailAddress: string;
  profilePictureId: string;
  profilePicture: string;
  isImpersonated: boolean;

  permissions: string[];
}

export type UserAccountType = UserAccount | undefined | null;
